import { AuditModel } from "./auditModel"

export class Notes extends AuditModel {
  public ClientId: number;
  public Notes: string;
  public noteId: any = 0;
  public ContextType: string;



}
export class Notifications {
  public notificationId: any;
  public notificationDetails: string;
  public notificationText: string;
  public status: string;
  public sName: string;
  public roleName: string;
  public commonid: number;
  public startdate: any;
  public duration: string;
  public isgroupby: any;
  public durationinhours: any;
  public markasRead: any;
  public isClear: any;
  public remindValue: any;
  public backgroundColor: any;
  public textColor: any;
  public fullName: string;
  public type: string;
}

export class RemindNotification {
  public NotificationId: any;
  public RemindDatetime: any;
  public RemindValue: any;
  public value: any;
}
export class NotificationSetting {
  public NotificationId: any;
  public UserId: any;
  public NotificationText: any;
  public IsEmailNotification: any;
  public IsAppNotification: any;
  public Type: any;
  public Status: any;
}

